"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var BonusGiftSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M14,6 C14.5522847,6 15,6.44771525 15,7 L15,14 C15,14.5522847 14.5522847,15 14,15 L7,15 C6.44771525,15 6,14.5522847 6,14 L6,12.82437 C5.60495874,12.7844289 5.25517716,12.5097567 5.13905311,12.104784 L3.20959162,5.37595217 C3.05736131,4.84506199 3.36432579,4.29128342 3.89521596,4.13905311 L10.6240478,2.20959162 C11.154938,2.05736131 11.7087166,2.36432579 11.8609469,2.89521596 L12.7512294,6 L14,6 Z M7,7 L7,14 L14,14 L14,7 L7,7 Z M10.8996852,3.17085332 L4.17085332,5.10031481 L6,11.4793074 L6,7 C6,6.44771525 6.44771525,6 7,6 L11.7109299,6 L10.8996852,3.17085332 Z M12.8508804,8.84327397 L9.5,12.2071068 L8.14147791,10.8461436 C7.94828915,10.6526077 7.94842235,10.339151 8.14177551,10.1457793 C8.33538442,9.95215189 8.64903558,9.95127814 8.84372027,10.1438239 L9.5,10.7928932 L12.1502099,8.14260468 C12.3435038,7.94930502 12.6568998,7.94930037 12.8501995,8.14259429 C13.0436134,8.33600826 13.0439158,8.64949248 12.8508804,8.84327397 Z" })));
};
BonusGiftSmall.displayName = 'BonusGiftSmall';
exports.default = BonusGiftSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=BonusGiftSmall.js.map